import { CrossdockStateKey } from "crossdock/base/CrossdockStateKey";
import { atom } from "recoil";

export const asnIdState = atom<string>({
  key: CrossdockStateKey.INBOUND_PRINT_PALLET_LABELS_ASN_ID,
  default: "",
});
